import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonImg, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../css/layout.css';

export function Modal_CreateIngredient (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [selectedFile, setSelectedFile] = useState(null);


    let [productPic1, setIngredientPic1] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);

    let [productImageNumber, setIngredientImageNumber] = useState(null);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);



    let [createIngredientAddition_type, setIngredientAddition_type] = useState(null);

    let [itemID, setItemID] = useState(null);
    let [createIngredientName, setIngredientName] = useState(null);
    let [createIngredientDescription, setIngredientDescription] = useState(null);
    let [createIngredientPartNum, setIngredientPartNum] = useState(null);
    let [createIngredientPhoneNumber, setIngredientPhoneNumber] = useState(null);
    let [createIngredientAddress, setIngredientAddress] = useState(null);
    let [createIngredientCity, setIngredientCity] = useState(null);
    let [createIngredientCountry, setIngredientCountry] = useState(null);
    let [createIngredientCostPerUnit, setIngredientCostPerUnit] = useState(null);
    let [createIngredientSalePrice, setIngredientSalePrice] = useState(null);
    let [createIngredientQtyInStock, setIngredientQtyInStock] = useState(null);
    let [createIngredientMeasurementUnitType, setIngredientMeasurementUnitType] = useState(null);
    let [createIngredientDateCreated, setIngredientDateCreated] = useState(null);
    let [createIngredientAddedBy, setIngredientAddedBy] = useState(null); 
    let [itemType, setItemType] = useState('FOOD');

    function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        setIngredientImageNumber("1");
        setIngredientPic1(event);
        setTakePhotoStatus1(false);
    }

    function handle_no_attachement(event) {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setIngredientImageNumber(event[0]);
            setIngredientPic1(noImageFile);

            alert("No Product Pics Option checked");

        })
    }


    function createIngredient(adminPassword)
    {
        
        
        //alert("In Crate Product Function");
       //alert(schema);
       //alert(createIngredientPartNum);
       //alert(createIngredientPhoneNumber);
       //alert(createIngredientCostPerUnit);
       // alert(pic4.value);
       //alert(totalProductPics);

        
        let formData = new FormData();
        formData.append('Tracker', '74400_createIngredient');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryItemID', itemID);
        formData.append('xInventoryItemName', createIngredientName);
        formData.append('xInventoryItemDescription', createIngredientDescription);
        formData.append('xInventoryVendorPartNum', createIngredientPartNum);
        formData.append('xInventoryVendorName', createIngredientPhoneNumber);
        formData.append('xInventoryVenderPhoneNumber', createIngredientAddress);
        formData.append('xInventoryVendorCity', createIngredientCity);
        formData.append('xInventoryVendorCountry', createIngredientCountry);
        formData.append('xInventoryItemCostPerUnit', createIngredientCostPerUnit);
        formData.append('xInventoryItemQtyInStock', createIngredientQtyInStock);
        formData.append('xInventoryItemUnitType', createIngredientMeasurementUnitType);
        formData.append('xInventoryItemType', itemType);
        //formData.append('xPic1', selectedFile);
        formData.append('xEnterAdminPassword', adminPassword);
        formData.append('sessionID', sessionID);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }


    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFile = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveProductPictures(event) { 

        setIngredientPic1(event.target.files[0]);
    
    }


    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event[0] = "1")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setIngredientImageNumber(event[1].target.dataset.id);
            setIngredientPic1(file);
        }
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        //alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createIngredient(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg");
        handle_no_attachement();

        if(props.data.itemTye == 'HOTEL')
        {
            setItemType('HOTEL');
        }

    }, [])
    
    //alert("IN CREATE INGREDIENT")

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: 'black'}}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>CREATE INGREDIENT</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
             <IonContent className='grid_content'>
            <IonSlides pager='true'>
                <IonSlide>
                <div style={{ height: '100%', overflowY: 'auto' }}>
                    <IonGrid>
                    <IonRow>
                        <IonCol>
                        <IonLabel for="itemType">Item Type</IonLabel>
                        </IonCol>
                        <IonCol>
                        <select name="productType" id='productType' onChange={(e) => setItemType(e.target.value) }>
                            {/*<option value='cc'>Credit Card</option>*/}
                            <option value='FOOD' selected='selected'>FOOD</option>
                            <option value='DRINKS'>DRINKS</option>
                            <option value='HOTEL'>HOTEL</option>
                            <option value='MISC'>MISC</option>
                        </select>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Name:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_2 && (
                            <IonInput
                            placeholder="Enter Product Name"
                            onIonChange={(e) => setIngredientName(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_2 && <IonText>{createIngredientName}</IonText>}
                        </IonCol>
                        {!row_2 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_2 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Description:</IonLabel>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        {row_3 && (
                            <textarea cols="40" rows="10"  placeholder="Enter Product Description" onChange={(e) => setIngredientDescription(e.target.value)} ></textarea>
                        )}
                        {!row_3 && <textarea cols="40" rows="10" value={createIngredientDescription} ></textarea>}
                        </IonCol>
                        {!row_3 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_3 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Part Number:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_4 && (
                            <IonInput
                            placeholder="Enter Product Part Number"
                            onIonChange={(e) => setIngredientPartNum(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_4 && <IonText>{createIngredientPartNum}</IonText>}
                        </IonCol>
                        {!row_4 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_4 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_4(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Phone Number:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_5 && (
                            <IonInput
                            placeholder="Enter Product Phone Number"
                            onIonChange={(e) => setIngredientPhoneNumber(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_5 && <IonText>{createIngredientPhoneNumber}</IonText>}
                        </IonCol>
                        {!row_5 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_5(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_5 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_5(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Address:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_6 && (
                            <IonInput
                            placeholder="Enter Product Address"
                            onIonChange={(e) => setIngredientAddress(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_6 && <IonText>{createIngredientAddress}</IonText>}
                        </IonCol>
                        {!row_6 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_6(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_6 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_6(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient City:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_7 && (
                            <IonInput
                            placeholder="Enter Product City"
                            onIonChange={(e) => setIngredientCity(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_7 && <IonText>{createIngredientCity}</IonText>}
                        </IonCol>
                        {!row_7 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_7(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_7 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_7(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Country:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_8 && (
                            <IonInput
                            placeholder="Enter Product Country"
                            onIonChange={(e) => setIngredientCountry(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_8 && <IonText>{createIngredientCountry}</IonText>}
                        </IonCol>
                        {!row_8 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_8(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_8 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_8(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Cost Per Unit:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_9 && (
                            <IonInput
                            placeholder="Enter Product Cost Per Unit"
                            onIonChange={(e) => setIngredientCostPerUnit(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_9 && <IonText>{createIngredientCostPerUnit}</IonText>}
                        </IonCol>
                        {!row_9 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_9(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_9 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_9(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Ingredient Sale Price:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_10 && (
                            <IonInput
                            placeholder="Enter Product Sale Price"
                            onIonChange={(e) => setIngredientSalePrice(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_10 && <IonText>{createIngredientSalePrice}</IonText>}
                        </IonCol>
                        {!row_10 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_10(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_10 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_10(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel>Quantity Available:</IonLabel>
                        </IonCol>
                        <IonCol>
                        {row_11 && (
                            <IonInput
                            placeholder="Enter Quantity Available"
                            onIonChange={(e) => setIngredientQtyInStock(e.detail.value)}
                            ></IonInput>
                        )}
                        {!row_11 && <IonText>{createIngredientQtyInStock}</IonText>}
                        </IonCol>
                        {!row_11 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_11(true)}>Update</IonButton>
                        </IonCol>
                        )}
                        {row_11 && (
                        <IonCol>
                            <IonButton onClick={() => setRow_11(false)}>Confirm</IonButton>
                        </IonCol>
                        )}
                    </IonRow>
                    <IonRow>
                        <IonCol>
                        <IonLabel for="ProductType">Measurement Unit</IonLabel>
                        </IonCol>
                        <IonCol>
                        <select name="productType" id='productType' onChange={(e) => setIngredientMeasurementUnitType(e.target.value) }>
                            {/*<option value='cc'>Credit Card</option>*/}
                            <option value='qty' selected='selected'>Unit</option>
                            <option value='lb'>Pounds</option>
                            <option value='ml'>Mililitters</option>
                            <option value='g'>grams</option>
                            <option value='kg'>Kilograms</option>
                            <option value='L'>Liters</option>
                        </select>
                        </IonCol>
                    </IonRow>
                    </IonGrid>
                </div>
                </IonSlide>
            </IonSlides>

            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>
        </IonContent>
        <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="6">
                            <IonButton onClick={() => setShowPasswordModal(true)}> Confirm </IonButton>
                        </IonCol>
                        <IonCol size="6">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
        </React.Fragment>
        )
}